import React from 'react';

interface FormFieldProps {
   label: string;
   type: string;
   value: string;
   onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
   placeholder: string;
   required?: boolean;
}

function FormField({ label, type, value, onChange, placeholder, required }: FormFieldProps) {
   return (
      <div>
         <label className="block text-xs font-mono text-silver mb-2">{label}</label>
         <input
            type={type}
            value={value}
            onChange={onChange}
            className="w-full px-4 py-3 bg-charcoal/50 border border-slate/50 rounded text-pearl font-mono text-sm focus:outline-none focus:border-amethyst transition-colors"
            placeholder={placeholder}
            required={required}
         />
      </div>
   );
}

export default FormField;
